import "./Main.scss";
import "./Sub.scss";
import { MdHomeFilled, MdKeyboardArrowRight } from "react-icons/md";
import { Link } from "react-router-dom";
function Sub(props) {
  return (
    <>
      <div className=" location_wrap">
        <div className="location">
          <Link to="/">
            <MdHomeFilled />
          </Link>
          <MdKeyboardArrowRight />
          <Link to={props.to}>{props.title}</Link>
        </div>
      </div>
    </>
  );
}

export default Sub;
